/**
 * Recuperação de replay: retoma a partir do menor cursor por sessão.
 */

import type { QueueItem } from '../queue/types';
import { shouldReplayItem } from './persistentReplay';
import { recordReplayDeduped } from '../telemetry';

export interface ReplayRecoveryPlan {
  items: QueueItem[];
  skippedAlreadyReplayed: number;
}

export function planReplayRecovery(items: QueueItem[]): ReplayRecoveryPlan {
  const out: QueueItem[] = [];
  let skipped = 0;
  for (const item of items) {
    if (shouldReplayItem(item.params.sessionId, item.sessionSequence)) {
      out.push(item);
    } else {
      skipped++;
      recordReplayDeduped(1);
    }
  }
  return { items: out, skippedAlreadyReplayed: skipped };
}

let replayRecoveryScheduled = false;

export function scheduleReplayRecovery(): void {
  replayRecoveryScheduled = true;
}

export function consumeReplayRecoveryScheduled(): boolean {
  if (!replayRecoveryScheduled) return false;
  replayRecoveryScheduled = false;
  return true;
}

export function getMinReplaySequenceForSession(
  items: QueueItem[],
  sessionId: string
): number {
  const sessionItems = items.filter(i => i.params.sessionId === sessionId);
  if (sessionItems.length === 0) return 0;
  return Math.min(...sessionItems.map(i => i.sessionSequence));
}
